import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './page-auth.css';
import { AuthWrapper } from "./AuthWrapper";
import { API_BASE_URL } from "../../services/api";
import { useDispatch } from 'react-redux';
import { setAdminData } from "../../store/adminSlice";

export const LoginPage = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // clear specific field error
  };

  // ✅ Simple username/password validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Username is required";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // valid if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: formData.email,
          password: formData.password,
        }),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok && data.status === "success") {
        const { admin, token } = data.data;

        dispatch(setAdminData({
          admin_id: admin.admin_id,
          admin_name: admin.admin_name,
          token: token,
        }));

        navigate("/dashboard");
      } else {
        setErrors({ general: data.message || "Invalid username or password" });
      }
    } catch (err) {
      setLoading(false);
      setErrors({ general: "Something went wrong. Please try again." });
      console.error("Login error:", err);
    }
  };

  return (
    <AuthWrapper>
      
      <h4 className="mb-2 text-black">Welcome to Proton! </h4>
      <p className="mb-4 text-black">Please sign in to your account and start the adventure</p>

      <form id="formAuthentication" className="mb-3" onSubmit={handleSubmit}>
        {/* Username */}
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Username
          </label>
          <input
            type="text"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            id="email"
            value={formData.email}
            onChange={handleChange}
            name="email"
            placeholder="Enter your username"
            autoFocus
          />
          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
        </div>

        {/* Password */}
        <div className="mb-3 form-password-toggle">
          <div className="d-flex justify-content-between">
            <label className="form-label" htmlFor="password">
              Password
            </label>
          </div>
          <div className="input-group input-group-merge">
            <input
              type="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              className={`form-control ${errors.password ? "is-invalid" : ""}`}
              name="password"
              placeholder="••••••••••••"
            />
          </div>
          {errors.password && (
            <div className="invalid-feedback d-block">{errors.password}</div>
          )}
        </div>

        {/* General error from API */}
        {errors.general && <div className="alert alert-danger mt-2">{errors.general}</div>}

        <div className="mb-3">
          <button
            className="btn btn-primary d-grid w-100"
            type="submit"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </div>
      </form>
    </AuthWrapper>
  );
};
